/**
 * Input Guards & Clipboard Fixes
 * Lifted from legacy _scripts.html so modern pages get them without Bootstrap.
 */

// Block non-numeric chars in <input type="number"> (commas, letters, etc.)
document.body.addEventListener('keypress', function (e) {
    if (e.target.type === 'number' && e.key !== '.' && e.key !== 'Backspace' && e.key !== 'Enter' &&
            (e.key < '0' || e.key > '9')) {
        e.preventDefault();
    }
});

// Phone input — sanitize <input type="tel"> and block invalid submissions.
// Server still runs sanitize_phone() — this is for UX, not security.
//
// As-you-type: block non-numeric chars (allow leading + and visual ()- ).
// On blur:     pretty-format US 10-digit as (901) 555-1234, else +international.
//              Mark .is-invalid if value is non-empty but unparseable.
// On submit:   if any tel input is invalid, prevent submit + flash toast.
//              Catches both native <form> submit and HTMX hx-post forms.

(function () {
    function digits(s) { return (s || '').replace(/\D/g, ''); }

    function parsePhone(raw) {
        // Returns { display, valid } for a phone string. Empty is valid (optional field).
        // Server normalizes to E.164 on save, so display is purely cosmetic.
        raw = (raw || '').trim();
        if (!raw) return { display: '', valid: true };
        var d = digits(raw);
        // US: 10 digits, or 11 digits starting with 1 (E.164 +1XXXXXXXXXX collapses here too).
        if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
        if (d.length === 10) {
            return {
                display: '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6),
                valid: true,
            };
        }
        // True international — only when leading + and not US-collapsible.
        if (raw.charAt(0) === '+') {
            return { display: '+' + digits(raw), valid: digits(raw).length >= 11 };
        }
        return { display: raw, valid: false };
    }

    function formatOnBlur(input) {
        var res = parsePhone(input.value);
        if (input.value !== res.display) input.value = res.display;
        input.classList.toggle('is-invalid', !!input.value && !res.valid);
        return res.valid || !input.value;
    }

    // Strip disallowed chars while typing — keep digits and visual chars.
    document.body.addEventListener('input', function (e) {
        if (!e.target || e.target.type !== 'tel') return;
        var cleaned = e.target.value.replace(/[^\d+()\-.\s]/g, '');
        if (cleaned !== e.target.value) e.target.value = cleaned;
        e.target.classList.remove('is-invalid');
    });

    // Pretty-format and validate on blur.
    document.body.addEventListener('blur', function (e) {
        if (e.target && e.target.type === 'tel') formatOnBlur(e.target);
    }, true);  // capture: blur doesn't bubble

    // Pretty-format existing values on first paint and after HTMX swaps.
    function reformatAll(root) {
        (root || document).querySelectorAll('input[type="tel"]').forEach(function (input) {
            if (input.value) formatOnBlur(input);
        });
    }
    document.addEventListener('DOMContentLoaded', function () { reformatAll(); });
    document.body.addEventListener('htmx:load', function (e) { reformatAll(e.target); });

    function validateForm(form) {
        var ok = true;
        // form.elements: only controls that submit with this form (form= attributes respected), skipping
        // disabled ones such as a hidden inline-create panel.
        Array.prototype.forEach.call(form.elements, function (input) {
            if (input.type === 'tel' && !input.disabled && !formatOnBlur(input)) ok = false;
        });
        if (!ok && window.SeeMe && SeeMe.toast) {
            SeeMe.toast.error('Please correct the highlighted phone number');
            var first = form.querySelector('input[type="tel"].is-invalid');
            if (first) first.focus();
        }
        return ok;
    }

    document.body.addEventListener('submit', function (e) {
        if (e.target && e.target.tagName === 'FORM' && !validateForm(e.target)) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    document.body.addEventListener('htmx:configRequest', function (e) {
        // formnovalidate: a helper button inside a larger form (e.g. inline "Add officer") posts on its own.
        if (e.detail.elt && e.detail.elt.formNoValidate) return;
        var form = e.detail.elt && e.detail.elt.closest && e.detail.elt.closest('form');
        if (form && !validateForm(form)) e.preventDefault();
    });
})();

// Force black text on clipboard copy so dark-mode doesn't paste invisible text
document.addEventListener('copy', function (e) {
    var selection = window.getSelection();
    var text = selection.toString();
    if (!text) return;
    e.preventDefault();
    e.clipboardData.setData('text/plain', text);
    var html = text.split('\n')
        .map(function (line) { return '<div style="color:black!important;margin:4px 0;">' + line + '</div>'; })
        .join('');
    e.clipboardData.setData('text/html',
        '<div style="color:black!important;font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',sans-serif;">' + html + '</div>');
});
